import React from 'react';
import PropTypes from 'prop-types';

var Select = (props) => {

  let size = "";
  switch(props.size){
    case 'lg': size = "input-lg"; break;
    case 'sm':
    default: size = "input-sm"
  }
  const validationClass = props.isValid ? "":"input-error";

  return (
    <select
      className={`form-control ${size} ${props.class} ${validationClass}`}
      value={props.value}
      disabled={props.isDisabled}
      onChange={(e) => { props.onChange(props.property, e.target.value, e) }}
      onBlur={(e) => { props.onBlur && props.onBlur(props.property, e.target.value, props.isRequired, e) }}
      onFocus={(e) => { props.onFocus && props.onFocus(props.property, e.target.value, props.isRequired, e) }}
    >
      {props.children}
    </select>
  )
}

Select.propTypes = {
  property: PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  value: PropTypes.string,
  class: PropTypes.string,
  isValid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool
}


Select.defaultProps = {
  value: "",
  class: "",
  isValid: true,
  isRequired: false,
  isDisabled: false
}

export default Select
